import { render, staticRenderFns } from "./SettingAudienceAdmission.vue?vue&type=template&id=bb366254&scoped=true&"
import script from "./SettingAudienceAdmission.vue?vue&type=script&lang=js&"
export * from "./SettingAudienceAdmission.vue?vue&type=script&lang=js&"
import style0 from "./SettingAudienceAdmission.vue?vue&type=style&index=0&id=bb366254&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb366254",
  null
  
)

export default component.exports